module.exports = __webpack_public_path__ + "assets/img/29_215.f36e8cff.jpg";